import { apiClient } from "./ApiClient";

const LIST_API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/list`;

export default {
  sections({ sort, order }) {
    return apiClient.get(
      `${LIST_API_URL}/sections?sort=${sort}&order=${order}`
    );
  },
  platoons({ sort, order, platoon_id }) {
    return apiClient.get(
      `${LIST_API_URL}/platoons?sort=${sort}&order=${order}&platoon_id=${platoon_id}`
    );
  },
  roles({ sort, order }) {
    return apiClient.get(`${LIST_API_URL}/roles?sort=${sort}&order=${order}`);
  },
  workoutTypes({ sort, order, is_active = -1 }) {
    return apiClient.get(
      `${LIST_API_URL}/workout_types?sort=${sort}&order=${order}&is_active=${is_active}`
    );
  },
  profileList({ sort, order, is_active = -1, is_top = -1 }) {
    return apiClient.get(
      `${LIST_API_URL}/profile_list?sort=${sort}&order=${order}&is_active=${is_active}&is_top=${is_top}`
    );
  },
};
